import { FunctionComponent, ReactElement, useContext } from 'react'

import { SurveyContext } from '@context/SurveyContext'
import { Choice, FlatQuestion, OneOfManyQuestion } from '@models/Survey'
import { AnswerType } from '@models/Survey/Answer'
import VerticalChoices from '@components/AnswerInput/OneOfManyInput/VerticalChoices/VerticalChoices'
import './QuestionsBrowser.scss'
import { TacticalQuestion } from '@models/Survey/Survey'

export interface OwnProps {
  onSelection: (answer: AnswerType) => void
  onAnswer?: (answer: AnswerType) => void
}

type Props = OwnProps

const QuestionsBrowser: FunctionComponent<Props> = ({ onSelection, onAnswer }): ReactElement => {
  const { questionsList, currentQuestion } = useContext(SurveyContext)
  const question = {
    choices: questionsList
      .filter((question) => !question.meta?.hideInSandbox && !(question as TacticalQuestion).meta?.tacticalReference)
      .map((question: FlatQuestion) => ({
        ...question,
        text: question?.text ?? question.label,
      })) as Choice[],
  } as OneOfManyQuestion

  return (
    <VerticalChoices
      className="QuestionsBrowser"
      question={question}
      answer={currentQuestion?.id}
      onSelection={onSelection}
      onAnswer={onAnswer}
    />
  )
}
export default QuestionsBrowser
